module.exports = __webpack_public_path__ + "img/icon-email.41bb53fc.svg";